exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sw {\r\n    float: left;\r\n    width: 100%;\r\n    height: 40px;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -ms-flex-align: center;\r\n        align-items: center;\r\n    box-shadow: 0 3px 1px -2px rgba(0, 0, 0, .2), 0 2px 2px 0 rgba(0, 0, 0, .14), 0 1px 5px 0 rgba(0, 0, 0, .12);\r\n  }\r\n  \r\n  .search {\r\n    -ms-flex: 1 1 auto;\r\n        flex: 1 1 auto;\r\n    -ms-flex-order: 2;\r\n        order: 2;\r\n    outline: none;\r\n    border: none;\r\n    border-radius: 0;\r\n    background: #fff;\r\n    padding: 8px;\r\n    font-family: 'Roboto', sans-serif;\r\n    height: 40px;\r\n    transition: all 0.05s ease-in-out;\r\n    -webkit-appearance: none;\r\n  }\r\n  \r\n  .go {\r\n    -ms-flex: 1 1 auto;\r\n        flex: 1 1 auto;\r\n    -ms-flex-order: 3;\r\n        order: 3;\r\n    max-width: 50px;\r\n    display: inline-block;\r\n    border: none;\r\n    background: #fff;\r\n    color: blue;\r\n    padding-top: 6px;\r\n    height: 40px;\r\n    transition: all 0.05s ease-in-out;\r\n    outline: none;\r\n  }", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/UI-PROJECTS/Helpline1097-UI/src/app/supervisor-emergency-contacts/supervisor-emergency-contacts.component.css
// module id = ../../../../../src/app/supervisor-emergency-contacts/supervisor-emergency-contacts.component.css
// module chunks = 0